<template>
  <div class="props-body">
    <div class="flex">
      <div class="allOrder">
        <div class="title">招聘道具</div>
        <div class="order-item">
          <img src="https://files.wondercv.com/B/liveicon/hot.png" class="hot-img">
          <div class="flex">
            <img class="order-item-icon" src="https://files.wondercv.com/PC/hr/cvproptop.png" alt="">
            <div class="order-title">
              <p>精准曝光</p>
              <p>职位曝光度低，简历投递量少？提升曝光，投递翻倍！</p>
            </div>
          </div>
          <div class="btn flex-c" @click="jobToTop">
            立即曝光
          </div>
        </div>
        <div class="order-item">
          <img src="https://files.wondercv.com/B/liveicon/new.png" class="hot-img">
          <div class="flex">
            <img class="order-item-icon" src="https://files.wondercv.com/PC/hr/cvpropphone.png" alt="">
            <div class="order-title">
              <p>查看电话 <span class="highlight">（当前剩余次数：{{phoneCount}}次)</span></p>
              <p>候选人回复慢，招聘效率低？查看电话，无需等待！</p>
            </div>
          </div>
          <div class="btn flex-c" @click="showBuyPhone">
            立即体验
          </div>
        </div>
        <div class="order-item">
          <div class="flex">
            <img class="order-item-icon" src="https://files.wondercv.com/PC/hr/cvpropsx.png" alt="">
            <div class="order-title">
              <p>职位刷新 <span class="highlight">（当前剩余次数：{{refreshCount || 0}}次）</span></p>
              <p>刷新职位更新时间，当天内提升曝光</p>
            </div>
          </div>
          <div class="btn flex-c" @click="()=>{jobRefreshDialogVisible = true}">
            立即体验
          </div>
        </div>
        <a href="https://mp.weixin.qq.com/s/zfVguYhX2vkdh9nJ_-aq4w" target="_blank">
          <div class="order-item">
            <div class="flex">
              <img class="order-item-icon" src="https://files.wondercv.com/PC/hr/cvpropvip.png" alt="">
              <div class="order-title">
                <p>专属定制</p>
                <p>1v1专属定制，提供企业招聘解决方案</p>
              </div>
            </div>
            <div class="btn flex-c">
              了解详情
            </div>
          </div>
        </a>   
      </div>
      <div class="operate">
        <div class="operate-top">
          <a href="/talent/order" target="_blank">
            <div class="operate-item">
              <i class="iconfont icongoumaijilu color_40"></i>
              <span>购买记录</span>
            </div>
          </a>
          <div class="operate-item" @click="downLoadInvoice">
            <i class="iconfont iconkaijufapiao color_40"></i>
            <span>开具发票</span>
          </div>
        </div>
        <div class="operate-bottom">
          <p>企业购买</p>
          <p>提供更多招聘方案，组合购买更加优惠</p>
          <img src="https://files.wondercv.com/hr/adv_wechat1.png" alt="">
          <p>扫码添加客户经理</p>
        </div>
      </div>
    </div>
    <!-- 购买手机次数 -->
    <job-pay-dialog 
      v-if="phoneDialogVisible" 
      payType="bPhone" 
      :orderPriceText="1050" 
      type="phone" 
      title="查看电话" 
      subtitle="无需等待候选人同意邀约，直接查看联系方式，购买后无使用限制，用完即止"
      @paidFunc="paidFunc"
      @closeFunc="closeFunc"/>
    <!-- 精准曝光支付弹窗 -->
    <job-pay-dialog v-if="jobPayDialogVisible"
                    type="top"
                    payType="bJobTop"
                    title="精准曝光"
                    subtitle=""
                    tipsText="该类产品为数字化商业产品，一经售出不支持退款退货<br />为不影响推荐效果，购买后不建议更换职位类别"
                    :jobArr="list"
                    :jobIndex="0"
                    :orderToken="orderToken"
                    :orderPriceText="199"
                    @paidFunc="paidFunc"
                    @closeFunc="closeFunc" />
    <!-- 二次确认弹框 -->
    <confirm-dialog v-if="confirmDialogVisible"
                tipsTitle="暂无在线职位"
                tipsText="发布在线职位后即可购买精准曝光"
                confirmButtonText="去发布"
                cancelButtonText="取消"
                @confirmFunc="confirmFunc"
                @cancelFunc="cancelFunc" />
    <!-- 获取刷新职位次数 -->
    <refreshPayDialog v-if="jobRefreshDialogVisible"
                    type="refresh"
                    payType="bJobRefresh"
                    title="职位刷新"
                    subtitle="刷新后可大大增加职位曝光度，候选人更容易"
                    :orderPriceText="50"
                    @paidFunc="()=>{ jobRefreshDialogVisible = false; getRefreshCount() }"
                    @refreshCount="getRefreshCount"
                    @closeFunc="closeFunc" />
  </div>
</template>

<script>
import actions from '@/actions/index'
import moment from 'moment'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import jobPayDialog from '@/components/block/JobPayDialog'
import refreshPayDialog from '@/components/block/JobPayDialog.vue'
import confirmDialog from '@/components/block/TipsBlock'
export default {
  name:'props',
  created(){
    // 获取查看电话次数
    this.getPhoneCount()
    // 获取职位刷新次数
    this.getRefreshCount()
  },
  components:{ jobPayDialog,confirmDialog,refreshPayDialog },
  data(){
    return {
      moment,
      phoneCount: 0,
      list: [], // 在线职位List
      jobPayDialogVisible: false, // 精准曝光支付
      phoneDialogVisible: false, // 查看手机次数支付
      confirmDialogVisible: false, // 确认弹框
      jobRefreshDialogVisible: false, // 职位刷新
      orderToken: '' ,
      refreshCount: 0 // 职位刷新次数  
    }
  },
  methods:{
    ...mapMutations('block',['updatePhoneNumberToken','updatePhoneNumberStateFun']),
    // 获取hr查看手机次数
    getPhoneCount() {
      actions.job_deliveries.get_phone_times().then(res => {
        if(res.code == 1000) {
          this.phoneCount = res.data.count
        }
      })
    },
    // 获取职位刷新次数
    getRefreshCount() {
      actions.recruit_infos.refreshJobCout().then(res => {
        if(res.code == 1000) {
          this.refreshCount = res.data.count
        }
      })
    },
    // 购买查看手机号次数
    async showBuyPhone() {
      let params = {
        plan: 'view_phone_30',
      }
      let res = await actions.recruit_infos.create_order(params)
      if(res.code === 1000) {
        this.updatePhoneNumberToken(res.data.order_token)
        // 显示全局的购查看电话次数弹窗
        this.updatePhoneNumberStateFun(true)
        // this.phoneDialogVisible = true
      }
    },
    // 精准曝光
    async jobToTop() {
      let loading = this.$message({
        message: '正在加载',
        iconClass:'el-icon-loading',
        duration:0,
      });
      // 获取在线职位
      let res = await actions.recruit_infos.get_recruit_infos_list({status: 'publish'})
      if(res.code == 1000) {   
        this.onlineJobsCount = res.data.online_jobs_count
        this.list = res.data.jobs
        // 判断有没有在线职位
        if(this.onlineJobsCount > 0 && this.list.length > 0 ) {
          // await this.createOrder(this.list[0].token)
          this.$router.push({path:'/talent/joblist',query: {fromProps: true}});
          // this.jobPayDialogVisible = true
        } else {
          this.confirmDialogVisible = true
        }
      } else {
        console.log('获取在线职位出错');
      }
      loading.close()
    },
    // 创建精准曝光订单
    async createOrder (token) {
      return new Promise(async (resove,reject) => {
        try {
          let params = {
            plan: 'top',
            job_token: token,
            start_time: this.moment().format('YYYY-MM-DD')
          }
          let res = await actions.recruit_infos.create_order(params)
          if (res.code === 1000) {
            // 获取订单 token
            this.orderToken = res.data.order_token
            resove()
          }
        } catch (e) {
          console.log(e) 
          reject(e)
        }
      })
    },
    // 支付成功的回调
    paidFunc () {
      this.jobPayDialogVisible = false
      this.phoneDialogVisible = false
      this.$message({
        message: '支付成功',
        type: 'success'
      })
      this.getPhoneCount();
    },
    // 关闭支付弹窗的回调
    closeFunc () {
      this.jobPayDialogVisible = false
      this.phoneDialogVisible = false
      this.jobRefreshDialogVisible = false
    },
    // 取消购买精准曝光
    cancelFunc() {
      this.confirmDialogVisible = false
    },
    // 去发布职位
    confirmFunc() {
      this.$router.push({path:'/talent/jobedit/create'})
    },
    // 增值税发票/拉起客服
    downLoadInvoice(){
      let udesk_container = document.querySelector('#udesk_btn a')
      if(udesk_container!=null){
        udesk_container.click()
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @mixin font-style($size,$weight,$color) {
    font-size: $size;
    font-weight: $weight;
    color: $color;
  }
  .props-body{
    padding: 16px 50px 0 50px;
    margin: auto;
    max-width: 1180px;
    .allOrder{  
      margin-right: 16px;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.15);
      border-radius: 6px;
      padding: 28px 24px 32px 24px;
      height: 610px;
      flex: 1;
      .title{
        @include font-style(22px, 500, #404040);
        margin-bottom: 24px;
      }
      .order-item{
        padding: 20px 26px 20px 20px;
        height: 116px;
        box-sizing: border-box;
        background-color: #f9f9f9;
        border-radius: 6px;
        margin-bottom: 16px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .order-title{
          padding-top: 14px;
          &>p:nth-of-type(1){
            @include font-style(18px, 600, #404040);
            margin-bottom: 14px;
            &>span{
              @include font-style(14px, 400, #404040);
            }
          }
          &>p:nth-of-type(2){
            @include font-style(16px, 400, #9c9c9c);
          }
        }
        .order-item-icon{
          width: 76px;
          height: 76px;
          border-radius: 6px;
          object-fit: contain;
          display: inline-block;
          margin-right: 18px;
        }
        .btn{
          cursor: pointer;
          width: 104px;
          height: 36px;
          background:#FFD799;
          border-radius: 18px;
          @include font-style(14px, 600, #874900);
          &:hover{
            opacity: 0.8;
          }
        }
        .tips{
          @include font-style(14px, 600, #fff);
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          right: 0;
          width: 76px;
          height: 23px;      
          background: linear-gradient(360deg, #FF8474 0%, #FFC8C0 100%);
          border-radius: 6px 0px 6px 0px;
        }
        .hot-img{
          width: 60px;
          height: 60px;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
    .operate{
      width: 290px;
      .operate-top{
        width: 290px;
        height: 114px;
        background: #FFFFFF;
        box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.15);
        border-radius: 6px;
        margin-bottom: 18px;
        padding: 14px 16px;
        box-sizing: border-box;
        .operate-item {
          width: 260px;
          height: 42px;
          border-radius: 19px;
          display: flex;
          align-items: center;
          padding-left: 16px; 
          box-sizing: border-box;
          cursor: pointer;
          &:hover{
            background: #F5F5F7;
          }
          &>span{
            margin-left: 15px;
            @include font-style(15px, 500, #404040);
          }
        }
      }
      .operate-bottom{
        width: 290px;
        height: 355px;
        background: #FFFFFF;
        box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.15);
        border-radius: 6px;
        box-sizing: border-box;
        padding: 26px 24px 24px 24px;
        &>img{
          width: 197px;
          height: 197px;
          display: block;
          margin: auto;
        }
        &>p:nth-child(1){
          @include font-style(18px, 500, #404040);
        }
        &>p:nth-child(2){
          @include font-style(14px, 400, #9c9c9c);
          margin-top: 14px;
          margin-bottom: 20px;
        }
        &>p:nth-of-type(3){
          @include font-style(14px, 400, #9c9c9c);
          margin-top: 16px;
          text-align: center;
        }
      }
    }
    .highlight{
      color:#FF6F37 !important;
    }
  }
</style>
